import React, {useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {
  videoActivityJsonSchema,
  videoActivityUiSchema,
  surveyAvailabilityJsonSchema,
  surveyAvailabilityUiSchema
} from '@/services/schema/activity';
import styles from '../SurveyActivitySetUp/SurveyActivitySetUp.module.scss';

const VideoActivitySetUp = ({
  activitySelection,
  formData,
  handleFormChange
}) => {
  const handleJsonChange = useCallback(
    (data) => {
      handleFormChange(data);
    },
    [handleFormChange]
  );

  const availabilityUi = useMemo(
    () =>
      surveyAvailabilityUiSchema(
        formData?.startDate || '',
        formData?.endDate,
        formData
      ),
    [formData]
  );

  return (
    <div
      className='flex w-full flex-col gap-8'
      data-testid='video-activity-card'>
      <div className='flex flex-col gap-4'>
        <h3 className='text-base font-bold text-white'>Activity Setup</h3>
        <div className={styles.surveySetupRow}>
          <div className={styles.activityTypeWrap}>{activitySelection}</div>
          <div className={styles.surveyFieldsWrap}>
            <JsonFormsWrapper
              jsonschema={videoActivityJsonSchema}
              uischema={videoActivityUiSchema(formData)}
              data={formData}
              onChange={handleJsonChange}
            />
          </div>
        </div>
      </div>
      <div className='flex flex-col gap-4'>
        <h3 className='text-base font-bold text-white'>Availability</h3>
        <div className={styles.availabilityRowWrap}>
          <JsonFormsWrapper
            jsonschema={surveyAvailabilityJsonSchema}
            uischema={availabilityUi}
            data={formData}
            onChange={handleJsonChange}
          />
        </div>
      </div>
    </div>
  );
};

VideoActivitySetUp.propTypes = {
  activitySelection: PropTypes.node,
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(VideoActivitySetUp);
